if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0; //truncate if number, or convert non-number to 0;
    padString = String(typeof padString !== "undefined" ? padString : " ");
    if (this.length >= targetLength) {
      return String(this);
    } else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
      }
      return padString.slice(0, targetLength) + String(this);
    }
  };
}

export const old_colors_1 = [
  "#0074D9",
  "#7FDBFF",
  "#39CCCC",
  "#3D9970",
  "#2ECC40",
  "#FFDC00",
  "#FF851B",
  "#FF4136",
  "#85144b",
  "#B10DC9",
  "#AAAAAA",
  "#000000",
];

export const old_colors_2 = [
  "rgb(255,59,48)",
  "rgb(255,149,0)",
  "rgb(255,204,0)",
  "rgb(76,217,100)",
  "rgb(90,200,250)",
  "rgb(0,122,255)",
  "rgb(88,86,214)",
  "rgb(255,45,85)",
];

export const old_colors_3 = [
  "rgb(239, 83, 80)",
  "rgb(236, 64, 122)",
  "rgb(171, 71, 188)",
  "rgb(92, 107, 192)",
  "rgb(66, 165, 245)",
  "rgb(38, 198, 218)",
  "rgb(38, 166, 154)",
  "rgb(102, 187, 106)",
  "rgb(255, 202, 40)",
  "rgb(255, 167, 38)",
  "rgb(255, 112, 67)",
  "rgb(141, 110, 99)",
  "rgb(120, 144, 156)",
];

export const colors = [
  "rgb(255, 112, 67)",
  "rgb(255, 167, 38)",
  "rgb(255, 202, 40)",
  "rgb(102, 187, 106)",
  "rgb(38, 166, 154)",
  "rgb(38, 198, 218)",
  "rgb(66, 165, 245)",
  "rgb(92, 107, 192)",
  "rgb(171, 71, 188)",
  "rgb(236, 64, 122)",
  "rgb(239, 83, 80)",
  "rgb(141, 110, 99)",
  "rgb(120, 144, 156)",
  "rgb(64,64,64)",
  "rgb(0,0,0)",
];

export function getSubs(minutes, period, periodLength) {
  let minutesCopy = JSON.parse(JSON.stringify(minutes));

  let matchingMinutes = minutesCopy.filter(
    (minute) =>
      minute.start >= (period - 1) * periodLength &&
      minute.end < period * periodLength
  );

  matchingMinutes.forEach((minute, index) => {
    let successor = minutesCopy.filter(
      (possibleMatch) =>
        possibleMatch.start === minute.end &&
        possibleMatch.position === minute.position &&
        possibleMatch.minuteId !== minute.minuteId
    )[0];
    minute.successor = successor;
    if (successor !== undefined) {
      successor.predecessor = minute;
    }
    //check if player switches positions (same player and end of one playing time is same as start of another playing time)
    let switchingPos = minutesCopy.filter(
      (possibleMatch) =>
        minute.id === possibleMatch.id &&
        minute.end === possibleMatch.start &&
        minute.minuteId !== possibleMatch.minuteId
    );
    if (switchingPos.length > 0) {
      minute.type = "switch";
      minute.switchSuccessor = switchingPos[0];
      switchingPos[0].switchPredecessor = minute;
    } else {
      minute.type = "sub";
    }
  });

  matchingMinutes.forEach((minute, index) => {
    if (
      minute.type === "sub" &&
      minute.hasOwnProperty("successor") &&
      minute.successor !== undefined
    ) {
      let finalSuccessor = minute.successor;
      let i = 0;
      while (finalSuccessor.hasOwnProperty("switchPredecessor") && i < 5) {
        i++;
        if (finalSuccessor.switchPredecessor.successor !== undefined) {
          finalSuccessor = finalSuccessor.switchPredecessor.successor;
        } else {
          break;
        }
      }
      minute.finalSuccessor = finalSuccessor;
    }
  });
  return matchingMinutes.sort((a, b) => a.end - b.end);
}

export function getSubsV2(minutes) {
  // 1) Group minutes by end time (oldPlayers) and start time (newPlayers)
  const endMap = new Map();
  const startMap = new Map();

  for (const m of minutes) {
    // Only add to endMap if 'end' is a valid number AND not zero-length
    // i.e., skip if start === end
    if (typeof m.end === "number" && m.start !== m.end) {
      if (!endMap.has(m.end)) {
        endMap.set(m.end, []);
      }
      endMap.get(m.end).push(m);
    }
    // Only add to startMap if 'start' is a valid number
    if (typeof m.start === "number") {
      if (!startMap.has(m.start)) {
        startMap.set(m.start, []);
      }
      startMap.get(m.start).push(m);
    }
  }

  // 2) Collect all times where both old and new players exist
  const endTimes = [...endMap.keys()];
  const intersectionTimes = endTimes
    .filter((t) => startMap.has(t))
    .sort((a, b) => a - b); // ascending order by time

  // 3) Build the result array
  const result = [];

  for (const time of intersectionTimes) {
    // Grab copies so we can splice out matched players
    const oldPlayers = [...endMap.get(time)];
    const newPlayers = [...startMap.get(time)];

    // We'll store switches and subs separately
    const switches = [];
    const subs = [];

    for (let j = newPlayers.length - 1; j >= 0; j--) {
      const newP = newPlayers[j];

      //try to find the same player in the oldPlayers array
      let oldP = oldPlayers.find((x) => x.id === newP.id);

      if (oldP) {
        if (oldP.position !== newP.position) {
          switches.push({ out: oldP, in: newP });
        }
        oldPlayers.splice(oldPlayers.indexOf(oldP), 1);
        newPlayers.splice(j, 1);
      }
    }

    for (let j = newPlayers.length - 1; j >= 0; j--) {
      const newP = newPlayers[j];

      //find the same position in the oldPlayers array
      let oldP = oldPlayers.find((x) => x.position === newP.position);

      if (oldP) {
        subs.push({ out: oldP, in: newP });
        oldPlayers.splice(oldPlayers.indexOf(oldP), 1);
        newPlayers.splice(j, 1);
      }
    }

    if (newPlayers.length > 0) {
      //just match the first player in the newPlayers array with the first player in the oldPlayers array for as many items are in the arrays
      for (let j = 0; j < newPlayers.length; j++) {
        const newP = newPlayers[j];
        const oldP = oldPlayers[j];
        subs.push({ out: oldP, in: newP });
      }
    }

    if (switches.length || subs.length) {
      const event = { time };
      const hasSwitches = switches.length > 0;
      const hasSubs = subs.length > 0;

      if (hasSwitches && hasSubs) {
        switches.sort((a, b) => a.out.id - b.out.id);
        subs.sort((a, b) => b.out.id - a.out.id);
      } else {
        if (hasSwitches) {
          switches.sort((a, b) => b.out.id - a.out.id);
        }
        if (hasSubs) {
          subs.sort((a, b) => b.out.id - a.out.id);
        }
      }

      if (hasSwitches) {
        event.switches = switches;
      }
      if (hasSubs) {
        event.subs = subs;
      }

      result.push(event);
    }
  }

  return result;
}

export function oldgetSubsV2(minutes) {
  // 1) Group minutes by end time (oldPlayers) and start time (newPlayers)
  const endMap = new Map();
  const startMap = new Map();

  for (const m of minutes) {
    // Only add to endMap if 'end' is a valid number AND not zero-length
    // i.e., skip if start === end
    if (typeof m.end === "number" && m.start !== m.end) {
      if (!endMap.has(m.end)) {
        endMap.set(m.end, []);
      }
      endMap.get(m.end).push(m);
    }
    // Only add to startMap if 'start' is a valid number
    if (typeof m.start === "number") {
      if (!startMap.has(m.start)) {
        startMap.set(m.start, []);
      }
      startMap.get(m.start).push(m);
    }
  }

  // 2) Collect all times where both old and new players exist
  const endTimes = [...endMap.keys()];
  const startTimes = [...startMap.keys()];
  const intersectionTimes = endTimes
    .filter((t) => startMap.has(t))
    .sort((a, b) => a - b); // ascending order by time

  // 3) Build the result array
  const result = [];

  for (const time of intersectionTimes) {
    // Grab copies so we can splice out matched players
    const oldPlayers = [...endMap.get(time)];
    const newPlayers = [...startMap.get(time)];

    // We'll store switches and subs separately
    const switches = [];
    const subs = [];

    // 3A) Identify "switches" => same ID, different position
    //     ( out: oldPlayer, in: newPlayer )
    for (let i = oldPlayers.length - 1; i >= 0; i--) {
      const oldP = oldPlayers[i];
      for (let j = newPlayers.length - 1; j >= 0; j--) {
        const newP = newPlayers[j];

        // Skip if same player continuing same position => no sub/switch
        if (oldP.id === newP.id && oldP.position === newP.position) {
          oldPlayers.splice(i, 1);
          newPlayers.splice(j, 1);
          break;
        }

        // If same ID but different position => switch
        if (oldP.id === newP.id && oldP.position !== newP.position) {
          switches.push({ out: oldP, in: newP });
          oldPlayers.splice(i, 1);
          newPlayers.splice(j, 1);
          break; // move on to the next oldPlayer
        }
      }
    }

    // 3B) Identify "subs" => same position, different ID
    //     ( out: oldPlayer, in: newPlayer )
    for (let i = oldPlayers.length - 1; i >= 0; i--) {
      const oldP = oldPlayers[i];
      for (let j = newPlayers.length - 1; j >= 0; j--) {
        const newP = newPlayers[j];
        if (oldP.position === newP.position && oldP.id !== newP.id) {
          subs.push({ out: oldP, in: newP });
          oldPlayers.splice(i, 1);
          newPlayers.splice(j, 1);
          break;
        }
      }
    }

    // 4) If we have any switches/subs, add them to the result object
    if (switches.length || subs.length) {
      const event = { time };

      // -- Sorting Logic (unchanged from earlier) --
      // If we have both switches and subs:
      //   - Switches => ascending by out.id
      //   - Subs => descending by out.id
      // If only one type is present => descending by out.id
      const hasSwitches = switches.length > 0;
      const hasSubs = subs.length > 0;

      if (hasSwitches && hasSubs) {
        switches.sort((a, b) => a.out.id - b.out.id);
        subs.sort((a, b) => b.out.id - a.out.id);
      } else {
        if (hasSwitches) {
          switches.sort((a, b) => b.out.id - a.out.id);
        }
        if (hasSubs) {
          subs.sort((a, b) => b.out.id - a.out.id);
        }
      }

      if (hasSwitches) {
        event.switches = switches;
      }
      if (hasSubs) {
        event.subs = subs;
      }

      result.push(event);
    }
  }

  return result;
}

export function getStartingPlayers(minutes, period, periodLength) {
  let matchingMinutes = minutes
    .filter((minute) => minute.start === (period - 1) * periodLength)
    .sort((a, b) => a.position - b.position);
  return matchingMinutes;
}

export function getPeriodArray(periods) {
  if (periods === 2) {
    return [1, 2];
  } else if (periods === 4) {
    return [1, 2, 3, 4];
  }
}

export function getPlayingTimes(players, minutes, currentTime) {
  let playingTimes = [];
  players.forEach((player) => {
    let time = 0;
    minutes.forEach((minute) => {
      if (minute.id === player.id) {
        time += (minute.end ?? currentTime ?? minute.start) - minute.start;
      }
    });
    playingTimes.push({ id: player.id, time: time });
  });
  return playingTimes;
}

export function calculateOverlap(item1, item2) {
  // Convert the start and end times to Date objects
  const start1 = new Date(item1.start);
  const end1 = new Date(item1.end);
  const start2 = new Date(item2.start);
  const end2 = new Date(item2.end);

  // Calculate the latest start time and the earliest end time
  const latestStart = new Date(Math.max(start1, start2));
  const earliestEnd = new Date(Math.min(end1, end2));

  // Calculate the difference in milliseconds
  const difference = earliestEnd - latestStart;

  // If the difference is negative, there is no overlap
  if (difference <= 0) {
    return false;
  }

  // Convert the difference to seconds and return it
  return true;
}

export function checkWarnings(minutes) {
  let warnings = [];
  minutes.forEach((minute) => {
    minutes
      .filter((x) => x.id === minute.id && minute.minuteId < x.minuteId)
      .forEach((checkMinute) => {
        if (calculateOverlap(minute, checkMinute)) {
          let times = [
            minute.start,
            minute.end,
            checkMinute.start,
            checkMinute.end,
          ].sort();
          warnings.push({
            type: 1,
            minuteA: minute,
            minuteB: checkMinute,
            start: times[1],
            end: times[2],
          });
        }
      });
  });
  return warnings;
}

export function getPositionString(positionsArray, positionLabels) {
  let positionString = Object.keys(positionsArray).reduce(
    (a, b) => a + (positionsArray[b] ? positionLabels[b] + ", " : ""),
    ""
  );
  if (positionString.length > 0) {
    return positionString.substring(0, positionString.length - 2);
  } else {
    return "no positions assigned";
  }
}

export function gaEvent(category, action, label) {
  //console.log(category,action,label);
  if (typeof window.ga === "function") {
    window.ga("send", "event", category, action, label);
  } else {
    console.log("tracking error: ga not a function", category, action, label);
  }
}

export function checkforSnap(
  minutes,
  start,
  end,
  distance,
  periodLength,
  selfMinuteId,
  selfPosition,
  actionDirection
) {
  let activePeriod = getPeriod(start, end, periodLength);
  let periodStart = (activePeriod - 1) * periodLength;
  let periodEnd = activePeriod * periodLength;

  let snapPoints = minutes.filter(
    (minute, index) =>
      activePeriod === getPeriod(minute.start, minute.end, periodLength) &&
      minute.position === selfPosition &&
      selfMinuteId !== minute.minuteId
  );

  //adding beginning and end of quarter to snappable spots
  snapPoints.push({
    start: periodStart,
    end: periodStart,
  });
  snapPoints.push({
    start: periodEnd,
    end: periodEnd,
  });

  let potentialSnapPoints = [];

  snapPoints.forEach((snapPoint) => {
    if (
      actionDirection !== "right" &&
      snapPoint.end < end &&
      snapPoint.end + distance > start
    ) {
      let pointToMeasureDistanceFrom =
        actionDirection === "left" ? end : (end + start) / 2;

      potentialSnapPoints.push({
        direction: "left",
        snapPoint: snapPoint,
        distance: Math.abs(pointToMeasureDistanceFrom - snapPoint.end),
      });
    }
    if (
      actionDirection !== "left" &&
      snapPoint.start > start &&
      snapPoint.start - distance < end
    ) {
      let pointToMeasureDistanceFrom =
        actionDirection === "right" ? start : (end + start) / 2;
      potentialSnapPoints.push({
        direction: "right",
        snapPoint: snapPoint,
        distance: Math.abs(snapPoint.start - pointToMeasureDistanceFrom),
      });
    }
  });

  //sort potentialSnapPoints by distance
  potentialSnapPoints.sort((a, b) => a.distance - b.distance);

  //return the closest snapPoint
  if (potentialSnapPoints.length > 0) {
    let snap = potentialSnapPoints[0];
    let tempStart = start;
    let tempEnd = end;

    if (snap.direction === "right") {
      tempEnd = snap.snapPoint.start;

      if (start % periodLength !== 0 && actionDirection !== "right") {
        tempStart = start + tempEnd - end;

        //check for maximmum point in time between tempStart amd TempEnd at position selfPosition that is not takem by playing time
        let obstructingMinutes = minutes
          .filter(
            (minute) =>
              minute.position === selfPosition &&
              minute.minuteId !== selfMinuteId &&
              minute.end > tempStart &&
              minute.end < tempEnd
          )
          .map((minute) => minute.end);

        if (obstructingMinutes.length === 0) {
          tempStart = Math.max(tempStart, periodStart);
        } else {
          tempStart = Math.max(tempStart, Math.min(...obstructingMinutes));
        }
      }
    } else if (snap.direction === "left") {
      tempStart = snap.snapPoint.end;

      if (tempEnd % periodLength !== 0 && actionDirection !== "left") {
        tempEnd = tempEnd + tempStart - start;

        let obstructingMinutes = minutes
          .filter(
            (minute) =>
              minute.position === selfPosition &&
              minute.minuteId !== selfMinuteId &&
              minute.start > tempStart &&
              minute.start < tempEnd
          )
          .map((minute) => minute.start);

        //obstructingMinutes.push(tempStart);
        if (obstructingMinutes.length === 0) {
          tempEnd = Math.min(tempEnd, periodEnd);
        } else {
          tempEnd = Math.min(
            periodEnd,
            Math.min(tempEnd, Math.max(...obstructingMinutes))
          );
        }
      }
    }

    let valid = checkIfMinuteValid(
      {
        start: tempStart,
        end: tempEnd,
        minuteId: selfMinuteId,
        position: selfPosition,
      },
      minutes
    );

    return {
      valid: valid,
      direction: snap.direction,
      minute: snap.snapPoint,
      newCoords: {
        start: Math.round(tempStart),
        end: Math.round(tempEnd),
      },
      newCoordsGridSnap: {
        start: Math.round(tempStart),
        end: Math.round(tempEnd),
      },
    };
  }

  let valid = checkIfMinuteValid(
    { start, end, minuteId: selfMinuteId, position: selfPosition },
    minutes
  );

  return {
    valid: valid,
    newCoords: {
      start,
      end,
    },
    newCoordsGridSnap: {
      start:
        actionDirection === "right"
          ? start
          : Math.round(start / distance) * distance,
      end:
        actionDirection === "left"
          ? end
          : Math.round(end / distance) * distance,
    },
  };
}

//sort minutes depending on action Direction

/*
  if (actionDirection === "left") {
    filteredMinutes.sort((a, b) => a.end - b.end);
  } else {
    filteredMinutes.sort((a, b) => b.start - a.start);
  }

  filteredMinutes.forEach((minute) => {
    if (start > minute.start && start - distance < minute.end) {
      if (found === false) {
        returnValue = { valid: false, direction: "left", minute: minute };
        found = true;
      }
    } else if (end + distance > minute.start && end < minute.end) {
      if (found === false) {
        returnValue = { valid: false, direction: "right", minute: minute };
        found = true;
      }
    }
  }); 
  return returnValue;
  return { valid: true };
}

/*

export function checkforSnap(
  minutes,
  start,
  end,
  distance,
  periodLength,
  selfMinuteId,
  selfPosition,
  actionDirection
) {
  console.log({
    minutes,
    start,
    end,
    distance,
    periodLength,
    selfMinuteId,
    selfPosition,
    actionDirection,
  });
  let returnValue = { valid: true };
  let found = false;
  let activePeriod = getPeriod(start, end, periodLength);
  let filteredMinutes = minutes.filter(
    (minute, index) =>
      activePeriod === getPeriod(minute.start, minute.end, periodLength) &&
      minute.position === selfPosition &&
      selfMinuteId !== minute.minuteId
  );

  //adding beginning and end of quarte to snappable spots
  filteredMinutes.push({
    start: (activePeriod - 1) * periodLength,
    end: (activePeriod - 1) * periodLength,
  });
  filteredMinutes.push({
    start: activePeriod * periodLength,
    end: activePeriod * periodLength,
  });

  //sort minutes depending on action Direction

  if (actionDirection === "left") {
    filteredMinutes.sort((a, b) => a.end - b.end);
  } else {
    filteredMinutes.sort((a, b) => b.start - a.start);
  }

  filteredMinutes.forEach((minute) => {
    if (start > minute.start && start - distance < minute.end) {
      if (found === false) {
        returnValue = { valid: false, direction: "left", minute: minute };
        found = true;
      }
    } else if (end + distance > minute.start && end < minute.end) {
      if (found === false) {
        returnValue = { valid: false, direction: "right", minute: minute };
        found = true;
      }
    }
  });
  return returnValue;
} */

export function getPlayerById(players, id) {
  return players.filter((x) => x.id === id)[0];
}

export function getPeriod(start, end, periodLength) {
  let middle = start + (end - start) / 2;
  let period = Math.ceil(middle / periodLength);
  return period;
}

export function getPlayingTime(minutes) {
  let returnValue = 0;
  minutes.forEach((minute) => {
    returnValue += minute.end - minute.start;
  });
  return Math.round(returnValue);
}

export function getTime(totalSeconds) {
  const isNegative = totalSeconds < 0;
  totalSeconds = Math.abs(Math.round(totalSeconds));
  let seconds = totalSeconds % 60;
  let minutes = Math.floor(totalSeconds / 60);
  return (
    (isNegative ? "-" : "") +
    minutes +
    ":" +
    seconds.toString().padStart(2, "0")
  );
}

export function reverseGetTime(timeString) {
  let [minutes, seconds] = timeString.split(":");
  return minutes * 60 + seconds * 1;
}

export function checkIfMinuteValid(minute, minutes) {
  let filteredMinutes = minutes.filter((x) => {
    return x.position === minute.position && x.minuteId !== minute.minuteId;
  });

  let valid = true;
  filteredMinutes.forEach((checkMinute) => {
    if (calculateOverlap(minute, checkMinute)) {
      valid = false;
    }
  });
  return valid;
}

export function checkforCollision(start, end, minutes, position, selfMinuteId) {
  let returnValue = { valid: true, collisions: [] };
  minutes
    .filter(
      (minute, index) =>
        minute.position === position && selfMinuteId !== minute.minuteId
    )
    .forEach((minute) => {
      if (start < minute.start && end > minute.end) {
        returnValue.valid = false;
        returnValue.collisions.push({ direction: "both", minute: minute });
      } else if (start > minute.start && start < minute.end) {
        returnValue.valid = false;
        returnValue.collisions.push({ direction: "left", minute: minute });
      } else if (end > minute.start && end < minute.end) {
        returnValue.valid = false;
        returnValue.collisions.push({ direction: "right", minute: minute });
      }
    });
  return returnValue;
}

export function createMinutesArray(
  players,
  periods,
  periodLength,
  stintOption
) {
  let playerAmount = players.length;
  if (playerAmount >= 5) {
    let lengthOfGame = periods * periodLength;
    let amountOfStints = playerAmount * stintOption;
    let lengthOfStint = lengthOfGame / amountOfStints;
    let minutes = [];
    let currentPlayerIndex = 0;
    let currentPlayer = players[0];

    for (
      let numberOfStint = 0;
      numberOfStint < amountOfStints;
      numberOfStint++
    ) {
      let startTimeOfStint = Math.round(numberOfStint * lengthOfStint);
      let endTimeOfStint = Math.round((numberOfStint + 1) * lengthOfStint);

      for (let position = 0; position <= 4; position++) {
        createPlayingTime(
          minutes,
          currentPlayer.id,
          position,
          startTimeOfStint,
          endTimeOfStint,
          periodLength,
          periods
        );
        [currentPlayerIndex, currentPlayer] = getNextPlayer(
          currentPlayerIndex,
          players
        );
      }
    }
    minutes = minutes.sort((a, b) => a.start - b.start);
    return minutes;
  } else return [];
}

export function createPlayersArray(playerAmount) {
  let players = [];
  for (let i = 1; i <= playerAmount; i++) {
    players.push({
      id: i,
      name: "Player " + i,
      colorId: i - 1,
      positions: [false, false, false, false, false],
      edited: true,
    });
  }
  return players;
}

function checkForEndOfPeriod(
  startTimeOfStint,
  endTimeOfStint,
  periodLength,
  periods
) {
  for (let i = 0; i < periods; i++) {
    if (
      startTimeOfStint < (i + 1) * periodLength &&
      endTimeOfStint > (i + 1) * periodLength
    ) {
      return (i + 1) * periodLength;
    }
  }
  return false;
}

function createPlayingTime(
  minutes,
  currentPlayerId,
  position,
  startTimeOfStint,
  endTimeOfStint,
  periodLength,
  periods
) {
  let endOfPeriodFound = checkForEndOfPeriod(
    startTimeOfStint,
    endTimeOfStint,
    periodLength,
    periods
  );
  if (!endOfPeriodFound) {
    minutes.push({
      id: currentPlayerId,
      position: position,
      start: startTimeOfStint,
      end: endTimeOfStint,
      minuteId: minutes.length,
    });
  } else {
    createPlayingTime(
      minutes,
      currentPlayerId,
      position,
      startTimeOfStint,
      endOfPeriodFound
    );
    createPlayingTime(
      minutes,
      currentPlayerId,
      position,
      endOfPeriodFound,
      endTimeOfStint
    );
  }
}

function getNextPlayer(currentPlayerIndex, players) {
  if (currentPlayerIndex === players.length - 1) {
    return [0, players[0]];
  } else {
    return [currentPlayerIndex + 1, players[currentPlayerIndex + 1]];
  }
}

export function remainingTimeInPeriod(time, start, end) {
  return Math.ceil(end - time);
}
